module.exports = __webpack_public_path__ + "fonts/fa-solid-900.b15db15f.woff2";